export default {
	title: "",
	subtitle: "TED",
  path: "transaction_ted",
	paragraphs: [
		"The TED payment is a normal bank transfer. For this type of transaction, instead of sharing with the customer a PIX Key, you’ll share the details of your bank account. It will be the Account Number, Account Branch, Beneficiary name and Document Number.",
        "After sharing these details, the customer uses it to pay you the value they need to. For this type of payment, you don’t need to create a transaction, only have the customer registered, as soon as we receive the payment, an automatic transaction will be created."
	],
	request:  {}
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionTED.js